import React, { useState } from 'react';
import { useViewMode } from './ViewModeContext';

export default function ViewModeToggle() {
  const { viewMode, setViewMode } = useViewMode();
  const [hovered, setHovered] = useState<'coordinator' | 'monitor' | null>(null);

  const containerStyle: React.CSSProperties = {
    display: 'flex',
    gap: 4,
    background: '#171923',
    borderRadius: 8,
    padding: 2,
  };

  const buttonStyle = (mode: 'coordinator' | 'monitor'): React.CSSProperties => {
    const isActive = viewMode === mode;
    const isHovered = hovered === mode && !isActive;
    return {
      padding: '6px 14px',
      borderRadius: 6,
      fontSize: 12,
      fontWeight: 600,
      cursor: 'pointer',
      border: 'none',
      transition: 'all 0.15s',
      background: isActive ? '#2b6cb0' : 'transparent',
      color: isActive ? '#fff' : isHovered ? '#e2e8f0' : '#a0aec0',
    };
  };

  return (
    <div style={containerStyle}>
      <button
        style={buttonStyle('coordinator')}
        onClick={() => setViewMode('coordinator')}
        onMouseEnter={() => setHovered('coordinator')}
        onMouseLeave={() => setHovered(null)}
      >
        📋 Coordinator View
      </button>
      <button
        style={buttonStyle('monitor')}
        onClick={() => setViewMode('monitor')}
        onMouseEnter={() => setHovered('monitor')}
        onMouseLeave={() => setHovered(null)}
      >
        🔍 Monitor View
      </button>
    </div>
  );
}
